import { useState } from "react";
import useTotp from "../../Service/hooks/useTOTP";


export default function ConfirmQRCodeStep({ onNext, onPrevious, registrationState }) {

    const { checkQRCode } = useTotp();

    const [token, setToken] = useState('');
    const [error, setError] = useState('');

    const checkToken = async () => {
        console.log("trying to check", token);
        let { success, error } = await checkQRCode({ otp: token });
        if(!error) {
            onNext();
        } else {
            setError(error);
        }
    }

    return <div className="flex flex-col gap-3">
        <h1 className="font-bold">Voer het nummer in</h1>
        <p>
            Voer nu hieronder het nummer in die u ziet verschijnen in uw google authenticator app op uw telefoon, naast het nummer ziet u een timer die aangeeft hoeveel tijd u heeft om dit te doen. Heeft u weinig tijd, wacht dan tot het volgende nummer verschijnt.
        </p>
        {error && <div className="bg-red-500 text-white p-2"> {error} </div> || null}
        <div method="post" className="flex flex-col gap-3">
            <div class="form">
                <div class="control">
                    <div class="label">
                        <label>Code (Google authenticator):</label>
                    </div>
                    <div class="input">
                        <input type="number" autoFocus={true} name="token" value={token} onChange={(e) => { setToken(e.target.value) }} />
                    </div>
                </div>
            </div>
            <div className="flex flex-row gap-3 w-full">
                <button className="flex-1 px-3 py-2 bg-green-500 text-white" onClick={() => checkToken(token)}>Volgende</button>
            </div>
        </div>
    </div>
}